import {Autocomplete, Box, TextField} from "@mui/material";
import React, {useState} from "react";
import {AutocompleteProps} from "../../components/SearchBox";
import {useGetWorkOrderQuery} from "./workorder_api";
import {Tables} from "../../apitypes";
import {OperationApiGet} from "../operation/operation_api";
import AvatarImage from "../storage/AvatarImage";


export default ({setFieldValue, value, name, error, label}: AutocompleteProps<Tables<"workOrder">>) => {

    const [filter, setFilter] = useState("");
    const {data} = useGetWorkOrderQuery({filter: filter, pageSize: 20, page: 0});

    return <Autocomplete
        id={name}
        options={data?.result || [] as Tables<"workOrder">[]}
        sx={{minWidth: "150px"}}
        value={value}
        onChange={(e, v: Tables<"workOrder"> | null) => {
            setFieldValue(name, v)
        }}
        getOptionLabel={(option: Tables<"workOrder">) => {
            return option.number + " " + option.buyerName;
        }}
        onInputChange={(e, v) => setFilter(v)}
        filterOptions={(v) => v}
        getOptionKey={o => o.id}
        renderOption={(props, option: Tables<"workOrder">) => {
            const {key, ...rest} = props
            return <Box key={key} component="li" sx={{'& > .MuiAvatar-root': {mr: 1}}} {...rest}>
                <AvatarImage image_url={option.image_url} bucket={"products"}/> {option.number} {option.buyerName}
            </Box>
        }}
        renderInput={(params) => (
            <TextField
                {...params}
                label={label}
                error={Boolean(error)}
                helperText={error}
            />
        )}
    />

}
